import * as React from 'react';
import './PageTemplate.css';

export const Footer: React.FC<{}> = (props) => {
  if (React.Children.count(props.children) > 0) {
    return <div className="pulse-footer">{props.children}</div>;
  }
  return null;
};
